import { render, staticRenderFns } from "./GatewayValidationRegister.html?vue&type=template&id=bc512a3e&scoped=true&external"
import script from "./GatewayValidationRegister.js?vue&type=script&lang=js&external"
export * from "./GatewayValidationRegister.js?vue&type=script&lang=js&external"
import style0 from "./GatewayValidationRegister.scss?vue&type=style&index=0&id=bc512a3e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc512a3e",
  null
  
)

export default component.exports